import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import {
	Alert,
	Autocomplete,
	Box,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextareaAutosize,
	TextField,
} from '@mui/material';
import { HeaderSection } from './BiasInfo';
import {
	columnStyle,
	getContactPhones,
	getFullName,
	getUserBasicInfo,
	justCentered,
} from '../../../helpers/utils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { registerAnnotationOrder } from '../../../actions/orderAnnotation';
import { sendWhatsApp, template1 } from '../../../helpers/whatsappApi';
import { ANNOTATION_TYPES } from '../../utils/lists';
import { AnnotationsColumn } from './AnnotationsColumn';
import { createNotification } from '../../../actions/notifications';
// import { createNotification } from '../../../actions/notifications';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const REASONS = [
	'Diferencias en el monto entre la Orden de compra, el CRM y la pre-factura.',
	'Errores es descripciones tanto en CRM como en fichas técnicas',
	'Errores en tela (descripciones y columna de TELAS)',
	'Errores en las ubicaciones de los bordados',
	'Falta de indicaciones en conversiones de tallas',
	'La falta de ingreso de la Orden de compra (no la ingresan en la nube) o cualquier otro documento.',
	'Errores en la pre-factura',
	'Diferencias entre el Listado de Empaque y el CRM',
	'Que no se ingresen las observaciones finales en el CRM',
];

export const AnnotationForm = ({
	open,
	handleClose,
	refreshOrder = null,
	order = null,
	annotationOption = 'new',
	handleUpdateStatus = null,
	reject = null,
	user = null,
}) => {
	return (
		<Dialog
			maxWidth='sm'
			fullWidth
			open={open}
			onClose={handleClose}
			TransitionComponent={Transition}
		>
			{/* Content */}
			{order && (
				<Box sx={{ flexGrow: 1 }}>
					<div style={{ padding: '20px' }}>
						<AnnotationsSection
							refreshOrder={refreshOrder}
							order={order}
							handleClose={handleClose}
							annotationOption={annotationOption}
							handleUpdateStatus={handleUpdateStatus}
							reject={reject}
							user={user}
						/>
					</div>
				</Box>
			)}
		</Dialog>
	);
};

const AnnotationsSection = ({
	order = null,
	handleClose = null,
	annotationOption = 'new',
	handleUpdateStatus = null,
	refreshOrder = null,
	reject = false,
}) => {
	// Annotations form
	const [noteType, setNoteType] = useState(null);
	const [notes, setNotes] = useState('');

	// Message text
	const [msgText, setMsgText] = useState('');

	// Reason type
	const [reasonType, setReasonType] = React.useState('');

	// Handle change reason type
	const handleChangeReasonType = (event) => {
		setReasonType(event.target.value);
	};

	// States
	const [newError] = useState(
		['problem', 'rejection'].includes(annotationOption)
	);
	const [isLoading, setIsLoading] = useState(false);
	const [isMsgSent, setIsMsgSent] = useState(null);

	// Store
	const { user = null } = useSelector((state) => state);

	// Handle submit notes
	const handleSubmit = async () => {
		// Send problem (whatsapp)
		if (newError) {
			// Prepare data
			const fullName = getFullName(user);
			const area =
				user.area?.name ||
				(user.user_type.id !== 4 ? 'Administrativa' : 'Sin área');
			// Send whatsapp message (template1 = report problem)
			setIsLoading(true);

			const newNotification = {
				order: {
					id: order?.id,
					number_order: order?.number_order,
					created_by: getUserBasicInfo(order?.created_by),
				},
				user: getUserBasicInfo(user),
				division: order?.division,
				message: notes,
				arrRecipients: getContactPhones(order?.contacts),
				isDone: false,
				type: annotationOption,
				template: 'pilu_alerta5', // Problem WhatsApp template ID,
			};

			// Create notification and get firestore ID
			const notificationId = (await createNotification(newNotification))
				.id;

			if (order.contacts.length > 0) {
				const newNotes = reasonType.length
					? `${reasonType} - ${notes}`
					: notes;
				sendWhatsApp(
					order,
					user,
					order.contacts,
					template1(fullName, area, order.number_order, newNotes),
					false
				)
					.then(async ({ data }) => {
						setIsMsgSent(true);
						if (data?.ok || data?.msg.includes('sent')) {
							setNotes('');
							setMsgText('Mensaje enviado');

							await registerAnnotationOrder({
								type: 'ALE', // ALERT
								description: notes,
								is_done: false,
								created_by: user.id,
								order: order.id,
								notification_id: notificationId,
							});

							if (reject) {
								handleUpdateStatus('ICF', true);
							}

							setIsMsgSent(true);
						} else {
							setMsgText(
								'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
							);
							setIsMsgSent(false);
						}
					})
					.catch((error) => {
						console.log(error);
						setMsgText(
							'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
						);
						setIsMsgSent(false);
					})
					.finally(() => {
						setIsLoading(false);
						setTimeout(() => {
							setIsMsgSent(null);
							setMsgText('');
							handleClose();
						}, 2000);
					});
			} else {
				setIsMsgSent(false);
				setMsgText(
					'La lista de contactos está vacía, agregue nuevos contactos'
				);
				setTimeout(() => {
					setIsLoading(false);
					setIsMsgSent(null);
					setMsgText('');
					handleClose();
				}, 4000);
			}
		} else {
			// Create new annotation
			registerAnnotationOrder({
				type: ANNOTATION_TYPES.find((item) => item.label === noteType)
					.name,
				description: notes,
				created_by: user.id,
				order: order.id,
			})
				.then(() => {
					setIsMsgSent(true);
					setNotes('');
					setMsgText('Anotación guardada');
					setIsMsgSent(true);
				})
				.catch((error) => {
					console.log(error);
					setMsgText(
						'Ocurrió un error al intentar crear la anotación. Intenta más tarde'
					);
					setIsMsgSent(false);
				})
				.finally(() => {
					setIsLoading(false);
					setNoteType(null);
					setTimeout(() => {
						setIsMsgSent(null);
						setMsgText('');
						handleClose();
					}, 4000);
				});
		}

		refreshOrder();
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	return (
		<>
			{annotationOption === 'list' ? (
				<AnnotationsColumn order={order} />
			) : (
				<>
					{user && (
						<>
							<div style={{ ...justCentered, ...columnStyle }}>
								<HeaderSection
									text={
										newError
											? 'Reportar problema'
											: 'Crear Anotación'
									}
								/>

								{(user?.area?.id === 1 ||
									user?.email ===
										'flopezramirez@hotmail.com') && (
									<FormControl
										fullWidth
										style={{ margin: '10px 0' }}
									>
										<InputLabel id='reason-label'>
											Razones
										</InputLabel>

										<Select
											labelId='reason-label'
											id='demo-simple-select'
											value={reasonType}
											label='Razón'
											onChange={handleChangeReasonType}
										>
											{REASONS.map((reason, index) => (
												<MenuItem
													key={index}
													value={reason}
												>
													{reason}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								)}
							</div>

							{isMsgSent !== null && msgText.length > 0 && (
								<Alert
									severity={isMsgSent ? 'success' : 'error'}
									style={{ margin: '30px 0 0 0' }}
								>
									{msgText}
								</Alert>
							)}
							{isMsgSent === null && (
								<>
									{!newError && (
										<Autocomplete
											style={{ marginTop: '-15px' }}
											fullWidth
											value={noteType}
											onChange={(_, value) => {
												setNoteType(value);
											}}
											options={[
												'Observación',
												'Compromiso',
												'Estrategia',
											]}
											renderInput={(params) =>
												TextFieldComponent(
													params,
													'Tipo de anotación'
												)
											}
										/>
									)}
									{newError && (
										<div style={{ textAlign: 'center' }}>
											<small>
												Este mensaje será enviado
												directamente a los
												administradores
											</small>
										</div>
									)}
									<TextareaAutosize
										value={notes}
										onChange={({ target }) =>
											setNotes(target.value)
										}
										aria-label='minimum height'
										minRows={5}
										readOnly={
											noteType === null && !newError
										}
										disabled={
											noteType === null && !newError
										}
										variant='standard'
										placeholder={
											noteType
												? `Escribe aquí tu ${noteType}`
												: newError
												? user?.area?.id === 1 ||
												  user?.email ===
														'flopezramirez@hotmail.com'
													? 'Agrega comentarios extra si es necesario'
													: 'Describe tu problema'
												: 'Selecciona un tipo de anotación'
										}
										style={{
											width: '100%',
											borderRadius: '8px',
											height: 100,
											fontFamily: 'Arial',
											fontSize: '17px',
											marginTop: '10px',
											padding: '10px',
											borderColor: '#E1DEDD',
										}}
									/>
									<LoadingButton
										style={{ margin: '15px 0' }}
										size='small'
										fullWidth
										disabled={notes.length === 0}
										variant='outlined'
										onClick={handleSubmit}
										loading={isLoading}
									>
										{newError ? 'Enviar' : 'Crear'}
									</LoadingButton>
									{order && (
										<LoadingButton
											size='small'
											fullWidth
											color='error'
											variant='outlined'
											onClick={handleClose}
										>
											Cancelar
										</LoadingButton>
									)}
								</>
							)}
						</>
					)}
				</>
			)}
		</>
	);
};
